import base from './base.repository';
export default {
    ...base,
    searchPeopleOrStructures(clientId, search, internal = 1){
        this.get(`destination?client=${clientId}&search=${search}&internal=${internal}`);
        return this;
    },
    searchPeople(clientId, search, internal = 1){
        //this.get(`clients/${clientId}/search/${search}/people`);
        this.get(`people/search?client=${clientId}&search=${search}&internal=${internal}`);
        return this;
    },
    searchStructures(clientId, search){
        this.get(`structures?client=${clientId}&name=${search}`);
        return this;
    },
    searchUsers(search){
        this.get(`users?search=${search}`);
        return this;
    }
}